import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Gallery } from '../components/Gallery';
import { ArtistStatement } from '../components/ArtistStatement';
import { About } from '../components/About';
import { Footer } from '../components/Footer';
export function Home() {
  return <main className="min-h-screen bg-offwhite" data-id="element-243">
      <Navbar data-id="element-244" />
      <Hero data-id="element-245" />
      <Gallery data-id="element-246" />
      <ArtistStatement data-id="element-247" />
      <About data-id="element-248" />
      <Footer data-id="element-249" />
    </main>;
}